import React, { FC, useEffect, useState } from "react";
import EnhancementIhx from "../../../../components/patient/Enhancement/IHX/EnhancementIhx";
import { Form } from "antd";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import useSelection from "antd/es/table/hooks/useSelection";
import {
  deleteUploadedDocument,
  downloadDocument,
  enhancementService,
  enhancementServiceIhx,
  getAllStarhealthDocumentsData,
} from "../../../../apis/patientService";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import { message } from "antd";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import dayjs from "dayjs";
import MultipleFilesPreviewModal from "../../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import { errorMessageModal } from "../../../../utils/modalMessage";

type EnhancementContainerIhxProps = {
  createEnhancement: boolean;
  closeCreateEnhancementModal: any;
  activeKey: any;
};

export interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
}

const EnhancementContainerIhx: FC<EnhancementContainerIhxProps> = ({
  createEnhancement,
  closeCreateEnhancementModal,
  activeKey,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients, enhancement, auth, preAuth } = useSelector(
    (state: RootState) => state
  );
  const [form] = Form.useForm();
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [enhancementId, setEnhancementId] = useState<any>(null);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  // const handleFileChange =
  //   (documentType: string, isMultiple: boolean) => (e: any) => {
  //     if (isMultiple) {
  //       const files = e?.fileList || [];
  //       if (files.length === 0) return;

  //       const selected = files?.map((f: any) => ({
  //         file: f.originFileObj,
  //         documentType,
  //       }));

  //       const previews = files?.map((f: any) => ({
  //         url: URL.createObjectURL(f.originFileObj),
  //         name: f.name,
  //         showUpload: true,
  //         documentType,
  //         isMultiple: isMultiple,
  //       }));

  //       setSelectedFiles(selected);
  //       setPreviewFiles(previews);
  //       setPreviewModalVisible(true);
  //     } else {
  //       if (Array.isArray(e)) {
  //         return e;
  //       }
  //       if (e?.file) {
  //         setSelectedFile({ file: e.file, documentType: documentType });
  //         setPreviewFile({
  //           url: URL.createObjectURL(e.file),
  //           name: e.file.name,
  //           showUpload: true,
  //           documentType: documentType,
  //         });
  //         setPreviewModalVisible(true);
  //       }
  //       return e?.target?.files;
  //     }
  //   };

  const handleFileChange = (documentType: string) => (e: any) => {
    const maxSize = 15 * 1024 * 1024;

    if (Array.isArray(e)) {
      return e;
    }
    if (e?.file) {
      setSelectedFile({ file: e.file, documentType: documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setPreviewModalVisible(true);
    }
    return e?.target?.files;
  };

  const fetchDocuments = async () => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );
        setDocumentTypes(AllDocumentList?.["Enhancement"]);
      } catch (err) {
        // errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDocuments();
    };

    if(createEnhancement) {
      fetchData();
    }
  }, [schemeMetaDataId, createEnhancement]);

  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];

    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });

    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };

  const handleUpload = async () => {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);
      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }
      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();
        // const updatedDocuments = updateOrAddDocument(
        //   uploadedDocumentUrl,
        //   documentRes
        // );
        const updatedDocuments = [...documentUrls, ...documentRes];
        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    };

  // const handleUpload = async () => {
  //   if (selectedFiles?.length > 0) {
  //     const CollectPostData = new FormData();
  //     if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //       CollectPostData.append(
  //         "hospitalId",
  //         patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //       CollectPostData.append(
  //         "patientId",
  //         patients?.fetchBasicDetails?.patientResponse?.id?.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //       CollectPostData.append(
  //         "caseId",
  //         patients?.fetchBasicDetails?.casesResponse?.id?.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //       CollectPostData.append(
  //         "visitId",
  //         patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
  //       );
  //     }
  //     CollectPostData.append("documentType", previewFile.documentType);

  //     selectedFiles?.map((fileObj, index) =>
  //       CollectPostData.append(`file${index}`, fileObj.file)
  //     );

  //     // if (selectedFiles?.length > 0) {
  //     //   selectedFiles.forEach((fileObj, index) => {
  //     //     // Extract the actual File object from your structure
  //     //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

  //     //     if (actualFile instanceof File) {
  //     //       CollectPostData.append("files", actualFile);
  //     //     }
  //     //   });
  //     // }

  //     try {
  //       const documentRes = await dispatch(
  //         UploadDocument({
  //           formData: CollectPostData,
  //           accessToken: auth.accessToken || "",
  //         })
  //       ).unwrap();

  //       // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
  //       const updatedDocuments = [...documentUrls, ...documentRes];

  //       setDocumentUrls(updatedDocuments);
  //       setPreviewModalVisible(false);
  //       message.success(
  //         `${documentRes?.[0]?.documentLabelType} uploaded successfully`
  //       );
  //       setSelectedFiles([]);
  //       setPreviewFiles([]);
  //     } catch (error) {
  //       console.error("Failed to upload document:", error);
  //     }
  //   } else {
  //     const CollectPostData = new FormData();
  //     if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //       CollectPostData.append(
  //         "hospitalId",
  //         patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //       CollectPostData.append(
  //         "patientId",
  //         patients?.fetchBasicDetails?.patientResponse?.id?.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //       CollectPostData.append(
  //         "caseId",
  //         patients?.fetchBasicDetails?.casesResponse?.id?.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //       CollectPostData.append(
  //         "visitId",
  //         patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
  //       );
  //     }
  //     CollectPostData.append("documentType", previewFile.documentType);

  //     if (selectedFile?.file) {
  //       CollectPostData.append("file", selectedFile?.file);
  //     }

  //     try {
  //       const documentRes = await dispatch(
  //         UploadDocument({
  //           formData: CollectPostData,
  //           accessToken: auth.accessToken || "",
  //         })
  //       ).unwrap();

  //       // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
  //       const updatedDocuments = [...documentUrls, ...documentRes];

  //       setDocumentUrls(updatedDocuments);
  //       setPreviewModalVisible(false);
  //       message.success(
  //         `${documentRes?.[0]?.documentLabelType} uploaded successfully`
  //       );
  //       setSelectedFile(null);
  //       setPreviewFile({
  //         url: "",
  //         name: "",
  //         showUpload: false,
  //         documentType: "",
  //       });
  //     } catch (error) {
  //       console.error("Failed to upload document:", error);
  //     }
  //   }
  // };

  // const handleUpload = async () => {
  //   const CollectPostData = new FormData();
  //   if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //     CollectPostData.append(
  //       "hospitalId",
  //       patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //     CollectPostData.append(
  //       "patientId",
  //       patients?.fetchBasicDetails?.patientResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //     CollectPostData.append(
  //       "caseId",
  //       patients?.fetchBasicDetails?.casesResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //     CollectPostData.append(
  //       "visitId",
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
  //     );
  //   }
  //   CollectPostData.append("documentType", previewFile.documentType);

  //   if (selectedFile?.file) {
  //     CollectPostData.append("file", selectedFile?.file);
  //   }

  //   try {
  //     const documentRes = await dispatch(
  //       UploadDocument({
  //         formData: CollectPostData,
  //         accessToken: auth.accessToken || "",
  //       })
  //     ).unwrap();

  //     const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);

  //     setDocumentUrls(updatedDocuments);
  //     setPreviewModalVisible(false);
  //     message.success(
  //       `${documentRes?.documentLabelType} uploaded successfully`
  //     );
  //   } catch (error) {
  //     console.error("Failed to upload document:", error);
  //   }
  // };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );

        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId)
        );
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      message.success("Document Downloaded successfully");
    } catch (error) {
      message.error("Download failed");
    }
  };

  //   useEffect(() => {
  //     const listOfUploadedDocuments = documentTypes?.flatMap(
  //       (item: any) =>
  //         item?.documentList?.map((doc: any) => ({
  //           id: doc?.id,
  //           documentName: doc?.documentName,
  //           documentType: doc?.documentType,
  //           documentUrl: doc?.documentUrl,
  //           documentLabelType: doc?.documentLabelType,
  //           deficiencyCheckStatus: doc?.deficiencyCheckStatus,
  //         })) || []
  //     );

  //     setDocumentUrls(listOfUploadedDocuments);
  //   }, [documentTypes]);

  const fetchData = async () => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const res = await enhancementServiceIhx.getEnhancementData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
        );
        if (res && Array.isArray(res)) {
          setEnhancementId(res?.[0]?.id);
          const updatedValues = {
            ...res?.[0],
            dateOfAdmission: res?.[0]?.dateOfAdmission
              ? dayjs(res?.[0]?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss")
              : null,
            dateOfDischarge: res?.[0]?.dateOfDischarge
              ? dayjs(res?.[0]?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss")
              : null,
            remarks: null,
          };

          form.setFieldsValue(updatedValues);
        }
      }
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    createEnhancement,
  ]);

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = {
        ...values,
        documentUrls,
        dateOfAdmission: values?.dateOfAdmission
          ? dayjs(values?.dateOfAdmission, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        dateOfDischarge: values?.dateOfDischarge
          ? dayjs(values?.dateOfDischarge, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
      };
      setIsSubmitting(true);
      await enhancementServiceIhx.saveEnhancementData(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        enhancementId,
        updatedValues
      );
      setIsSubmitting(false);
      successMessage("Enhancement Created Successfully");
      setDocumentUrls([]);
      setDocumentTypes([]);
      await getTimelineDetail();
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
      closeCreateEnhancementModal();
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <EnhancementIhx
        form={form}
        createEnhancement={createEnhancement}
        closeCreateEnhancementModal={closeCreateEnhancementModal}
        documentTypes={documentTypes}
        documentUrls={documentUrls}
        handleFileChange={handleFileChange}
        handleOpen={handleOpen}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />

      {selectedFile?.file && !selectedFiles?.length && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => setPreviewModalVisible(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.lastModified || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
        isIntimated={
          preAuth?.stepperData?.visitStages?.find(
            (stage: any) =>
              String(stage?.visitStageId) === String(activeKey),
          )?.intimated
        }
      />

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}
    </div>
  );
};

export default EnhancementContainerIhx;
